var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriple20Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.88in",
    height: "4in",
    viewBox: "0 0 423 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m119.91,207.91v-40.19h-40.24c2.21,21.01,19.22,38.01,40.24,40.19Z",
    fill: "#faa21b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m79.71,158.75h40.19v-40.24c-21.01,2.21-38.01,19.22-40.19,40.24Z",
    fill: "#faa21b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m79.71,109.56h40.19v-40.24c-21.01,2.21-38.01,19.22-40.19,40.24Z",
    fill: "#faa21b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m128.86,69.37v40.19h40.24c-2.21-21.01-19.22-38.01-40.24-40.19Z",
    fill: "#faa21b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m169.06,118.52h-40.19v40.24c21.01-2.21,38.01-19.22,40.19-40.24Z",
    fill: "#faa21b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m178.01,109.56h40.19v-40.24c-21.01,2.21-38.01,19.22-40.19,40.24Z",
    fill: "#faa21b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m227.16,69.37v40.19h40.24c-2.21-21.01-19.22-38.01-40.24-40.19Z",
    fill: "#faa21b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m267.36,118.52h-40.19v40.24c21.01-2.21,38.01-19.22,40.19-40.24Z",
    fill: "#faa21b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m218.25,158.75v-40.19h-40.24c2.21,21.01,19.22,38.01,40.24,40.19Z",
    fill: "#faa21b"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m150.18,176.27v31.63h-8.96v-31.63s-12.36,0-12.36,0v-8.56h33.73v8.56h-12.42Z",
    fill: "#1c1d1d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m180.96,188.23c-.96-.23-1.87-.28-2.72-.28-3.46,0-6.58,2.04-6.58,7.65v12.3h-8.62v-28.18h8.33v3.8c1.47-3.17,5.05-4.08,7.31-4.08.85,0,1.7.11,2.27.28v8.5Z",
    fill: "#1c1d1d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m190.43,166.07c2.83,0,5.1,2.27,5.1,5.05s-2.27,5.05-5.1,5.05c-2.72,0-4.99-2.27-4.99-5.05,0-2.78,2.27-5.05,4.99-5.05Zm-4.25,41.84v-28.18h8.62v28.18h-8.62Z",
    fill: "#1c1d1d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m200.78,218.68v-38.95h8.33v2.89c1.19-1.81,4.25-3.57,8.28-3.57,8.16,0,13.1,6.24,13.1,14.68,0,8.62-5.56,14.8-13.44,14.8-3.63,0-6.35-1.25-7.65-2.83v12.98h-8.62Zm14.85-31.86c-3.34,0-6.35,2.27-6.35,6.97,0,4.65,3,7.03,6.35,7.03,3.4,0,6.41-2.32,6.41-7.03,0-4.71-3-6.97-6.41-6.97Z",
    fill: "#1c1d1d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m234.58,207.91v-41.04h8.62v41.04h-8.62Z",
    fill: "#1c1d1d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m275.64,199.8c-1.36,4.88-5.84,8.96-12.98,8.96-7.77,0-14.68-5.56-14.68-15.02,0-9.07,6.75-14.85,14.06-14.85,8.73,0,14.12,5.39,14.12,14.46,0,1.19-.11,2.49-.17,2.66h-19.61c.17,3.17,3.06,5.44,6.41,5.44,3.12,0,4.88-1.48,5.67-3.69l7.2,2.04Zm-7.82-9.35c-.11-2.15-1.59-4.76-5.67-4.76-3.63,0-5.44,2.66-5.61,4.76h11.28Z",
    fill: "#1c1d1d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m280.86,185.8c-.17-.45-.34-1.93-.34-3.06,0-6.58,4.93-12.47,13.78-12.47,8.45,0,13.66,5.5,13.66,12.08,0,4.76-2.55,8.67-7.26,11.45l-6.97,4.14c-1.08.68-1.98,1.42-2.49,2.49h17.01v7.48h-27.95c0-6.75,1.93-12.3,8.67-16.21l6.01-3.51c2.89-1.7,4.02-3.23,4.02-5.67,0-2.32-1.64-4.37-4.93-4.37-3.46,0-5.16,2.38-5.16,5.44,0,.74.11,1.53.34,2.27l-8.39-.06Z",
    fill: "#1c1d1d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m315.1,176.56c2.44-3.69,6.52-6.29,12.47-6.29,6.01,0,10.09,2.61,12.53,6.29,2.55,3.86,3.23,8.45,3.23,12.98s-.68,9.13-3.23,12.98c-2.44,3.63-6.52,6.29-12.53,6.29-5.95,0-10.03-2.67-12.47-6.29-2.55-3.85-3.23-8.45-3.23-12.98,0-4.53.68-9.13,3.23-12.98Zm7.09,20.98c1.02,2.04,2.66,3.4,5.38,3.4,2.78,0,4.37-1.36,5.39-3.4,1.08-2.15,1.42-5.05,1.42-7.99,0-2.95-.34-5.84-1.42-7.99-1.02-2.04-2.61-3.4-5.39-3.4-2.72,0-4.37,1.36-5.38,3.4-1.02,2.15-1.36,5.05-1.36,7.99,0,2.95.34,5.84,1.36,7.99Z",
    fill: "#1c1d1d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriple20Logo);
export default __webpack_public_path__ + "static/media/triple20logo.ab944498b888b2866176c56c77fb7914.svg";
export { ForwardRef as ReactComponent };